export default __webpack_public_path__ + "static/media/hostaway_step7.94636938.jpg";